import { render } from "./InfoImageModule.vue?vue&type=template&id=397d1dbc&scoped=true"
import script from "./InfoImageModule.vue?vue&type=script&lang=js"
export * from "./InfoImageModule.vue?vue&type=script&lang=js"

import "./InfoImageModule.vue?vue&type=style&index=0&id=397d1dbc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397d1dbc"]])

export default __exports__